import { JobAgeKey } from '@/domain/job-details/components/header/header.types';

export const ONE_HOUR_IN_MS = 60 * 60 * 1000;
const ONE_DAY_IN_MS = 24 * ONE_HOUR_IN_MS;

export const daysInMs = (days: number): number => days * ONE_DAY_IN_MS;

export const getTimeDifferenceInMilis = (date: string): number => {
  const actualDate = new Date();
  const publicationDate = new Date(date);
  return Math.abs(actualDate.getTime() - publicationDate.getTime());
};

export const getMatchingJobAgeKey = (
  postingDate?: string | null,
  expireDate?: string | null
): JobAgeKey | undefined => {
  if (!postingDate) return;
  const postingDateInMilis = getTimeDifferenceInMilis(postingDate);
  const todayInMilis = getTimeDifferenceInMilis(new Date().toISOString());

  if (postingDateInMilis <= daysInMs(3)) {
    return 'JOBS_POSTING_EARLY_APPLICANT_MARKER';
  }

  if (expireDate && getTimeDifferenceInMilis(expireDate) - todayInMilis <= daysInMs(7)) {
    return 'JOBS_POSTING_LAST_CHANCE_MARKER';
  }

  if (postingDateInMilis >= daysInMs(15) && postingDateInMilis <= daysInMs(30)) {
    return 'JOBS_POSTING_ACTIVELY_RECRUITING_MARKER';
  }
};
